'use client';

import { c as _c } from "react/compiler-runtime";
import { type FC, useMemo } from 'react';
import { CheckOutlined, CloseOutlined, SearchOutlined, Select, type SelectProps } from '@/utils/antd-imports';
import Loader from './Loader';
import styles from './SearchSelect.module.css';
export interface SearchSelectOption {
  value: string | number;
  label: string;
}
interface SearchSelectProps {
  value?: number[] | string[];
  onChange: (value: number[] | string[]) => void;
  placeholder?: string;
  className?: string;
  options?: SearchSelectOption[];
  isFetching?: boolean;
  allowClear?: boolean;
  searchValue: string;
  filterOption?: SelectProps['filterOption'];
  setSearchValue: (value: string) => void;
}
export const SearchSelect: FC<SearchSelectProps> = t0 => {
  const $ = _c(41);
  const {
    value: t1,
    onChange,
    placeholder,
    className: t2,
    options: t3,
    allowClear: t4,
    searchValue: t5,
    isFetching: t6,
    setSearchValue,
    filterOption: t7
  } = t0;
  let t8;
  if ($[0] !== t1) {
    t8 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const value = t8;
  const className = t2 === undefined ? "" : t2;
  let t9;
  if ($[2] !== t3) {
    t9 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const options = t9;
  const allowClear = t4 === undefined ? true : t4;
  const searchValue = t5 === undefined ? "" : t5;
  const isFetching = t6 === undefined ? false : t6;
  const filterOption = t7 === undefined ? false : t7;
  let t10;
  if ($[4] !== setSearchValue) {
    t10 = input => {
      setSearchValue(input);
    };
    $[4] = setSearchValue;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const handleSearch = t10;
  let t11;
  if ($[6] !== onChange || $[7] !== setSearchValue) {
    t11 = newValue => {
      onChange(newValue);
      setSearchValue("");
    };
    $[6] = onChange;
    $[7] = setSearchValue;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  const handleChange = t11;
  let t12;
  if ($[9] !== options || $[10] !== value) {
    let t13;
    if ($[12] !== value) {
      t13 = option => value.findIndex(v => v === option.value) === -1;
      $[12] = value;
      $[13] = t13;
    } else {
      t13 = $[13];
    }
    t12 = options.filter(t13);
    $[9] = options;
    $[10] = value;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const selectOptions = t12;
  const t13 = `h-[55px] w-full grow basis-0 rounded-lg bg-[#392f99] ${className}`;
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <CheckOutlined className="text-white" />;
    t15 = [];
    $[14] = t14;
    $[15] = t15;
  } else {
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] !== handleChange || $[17] !== value) {
    t16 = t17 => {
      const [newValue_0] = t17;
      return handleChange([...value, newValue_0] as number[] | string[]);
    };
    $[16] = handleChange;
    $[17] = value;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== isFetching) {
    t17 = isFetching ? <Loader /> : "No results found";
    $[19] = isFetching;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== allowClear) {
    t18 = allowClear ? <CloseOutlined /> : undefined;
    $[21] = allowClear;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t18) {
    t19 = {
      clearIcon: t18
    };
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  let t21;
  let t22;
  let t23;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <SearchOutlined style={{
      color: "rgba(255, 255, 255, 0.4)"
    }} />;
    t21 = {
      backgroundColor: "transparent",
      border: "none",
      outline: "none"
    };
    t22 = {
      popup: {
        root: {
          backgroundColor: "transparent",
          border: "none",
          padding: "0",
          zIndex: 9999
        }
      }
    };
    t23 = {
      popup: {
        root: "search-select-popup"
      }
    };
    $[25] = t20;
    $[26] = t21;
    $[27] = t22;
    $[28] = t23;
  } else {
    t20 = $[25];
    t21 = $[26];
    t22 = $[27];
    t23 = $[28];
  }
  let t24;
  if ($[29] !== filterOption || $[30] !== handleSearch || $[31] !== placeholder || $[32] !== searchValue || $[33] !== selectOptions || $[34] !== t16 || $[35] !== t17 || $[36] !== t19) {
    t24 = <Select mode="multiple" tagRender={_temp} autoClearSearchValue={false} menuItemSelectedIcon={t14} value={t15} onChange={t16} placeholder={placeholder} notFoundContent={t17} options={selectOptions} allowClear={t19} searchValue={searchValue} onBlur={_temp2} showSearch={true} filterOption={filterOption} onSearch={handleSearch} className={`h-full w-full ${styles.searchSelect}`} suffixIcon={t20} style={t21} styles={t22} classNames={t23} />;
    $[29] = filterOption;
    $[30] = handleSearch;
    $[31] = placeholder;
    $[32] = searchValue;
    $[33] = selectOptions;
    $[34] = t16;
    $[35] = t17;
    $[36] = t19;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== t13 || $[39] !== t24) {
    t25 = <div className={t13}>{t24}</div>;
    $[38] = t13;
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  return t25;
};
function _temp() {
  return <></>;
}
function _temp2() {}